module.exports = __webpack_public_path__ + "media/images/flags/sc-924e8cec15dda01b60323714fe865a6f.svg";